<template>
    <van-swipe
            vertical
            class="notice-swipe"
            :autoplay="3000"
            :touchable="false"
            :show-indicators="false"
    >
        <van-swipe-item v-for="(item,index) in date" :key="index">
            <div class="item">
                <div class="name">{{ item.name }}</div>
                <div class="phone">{{ item.phone }}</div>
                <div class="info">{{ item.info }}</div>
            </div>
        </van-swipe-item>

    </van-swipe>

</template>

<script setup>
import {reactive} from "vue";

let date = reactive([{
    name: '张**',
    phone: '152****0136',
    info: '2分钟前报名'
}, {
    name: '赵**',
    phone: '186****9845',
    info: '10分钟前报名'
}, {
    name: '周**',
    phone: '135****6998',
    info: '12分钟前报名'
}, {
    name: '冯**',
    phone: '155****8875',
    info: '半小时前报名'
}, {
    name: '李**',
    phone: '131****6688',
    info: '一小时前报名'
}])

</script>


<style scoped>
.item {
    display: flex;
}

.name {
    margin-right: 1.5rem;
}

.phone {
    margin-right: 1.5rem;
}

.info {

}
</style>